import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { IBaseSearchRequest, IPagedResults } from 'src/app/core/models/base';
import { environment } from 'src/environments/environment';
import { IAssignmentService, ICreateAssignmentServiceRequest, IUpdateAssignmentServiceRequest } from '../models/assignment-service';

@Injectable({
  providedIn: 'root'
})
export class AssignmentServicesService {

  constructor(
    private http: HttpClient,
  ){}

  searchAssignmentServices(request: IBaseSearchRequest){
    return this.http.post<IPagedResults<IAssignmentService[]>>(
      `${environment.baseUrl}/v1/AssignmentService/searchAssignmentServices`,
      request
    )
  }

  getAssignmentService(id: string){
    return this.http.get<IAssignmentService>(
      `${environment.baseUrl}/v1/AssignmentService/getAssignmentService/${id}`
    )
  }

  createAssignmentService(request: ICreateAssignmentServiceRequest){
    return this.http.post<string>(
      `${environment.baseUrl}/v1/AssignmentService/createAssignmentService`,
      request
    )
  }

  updateAssignmentService(request: IUpdateAssignmentServiceRequest){
    return this.http.put<string>(
      `${environment.baseUrl}/v1/AssignmentService/updateAssignmentService/${request.id}`,
      request
    )
  }

  deleteAssignmentService(id: string){
    return this.http.delete<string>(
      `${environment.baseUrl}/v1/AssignmentService/deleteAssignmentService/${id}`
    )
  }
}
